import { AwsRum } from 'aws-rum-web'
import { ApplicationConfiguration } from '@/types'; 


export function initRum(appConfig: ApplicationConfiguration | null) {
  try {
    if (!appConfig || !appConfig.awsRum.active) {
      // console.debug('RUM is not active')
      return
    }

    let domain = window.location.hostname;
    if (domain === 'localhost') {
      // console.debug("Disabling RUM, you'll just get a bunch of errors when running locally.")
      return
    }

    const awsRumConfig = appConfig.awsRum
    const partialConfig = {
      sessionSampleRate: 1,
      identityPoolId: awsRumConfig.identityPoolId,
      endpoint: awsRumConfig.endpoint,
      telemetries: awsRumConfig.telemetries,
      allowCookies: true,
      enableXRay: true
    }

    const APPLICATION_VERSION = VERSION.npm_package_version
    const APPLICATION_ID = awsRumConfig.applicationId
    const APPLICATION_REGION = awsRumConfig.applicationRegion

    new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, partialConfig)
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.error('Error initializing CloudWatch RUM web client')
    console.error(error)
  }
}
